module.exports = function () {
  return new Worker(__webpack_public_path__ + "e16319ada080c8967bb1.worker.js");
};